import { render, staticRenderFns } from "./Reverse.vue?vue&type=template&id=08efb93f"
import script from "./Reverse.vue?vue&type=script&lang=js"
export * from "./Reverse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports